import { Stack } from '@mui/material'
import { observer } from 'mobx-react'
import React from 'react'
import { Mode } from '../NewServiceResultsDrawer'
import { ActiveOrder, CheckSerialResponse } from '../types/NewDrawers.types'
import NewServiceDrawerElement from './NewServiceDrawerElement'

interface RequestListProps {
  mode: Mode
  serialResponse: CheckSerialResponse | undefined
  watch: any
  selectedServiceRequest: ActiveOrder | null
  openedAccordionIndex: number
  setOpenedAccordionIndex: (index: number) => void
  getOnCheck: (request: ActiveOrder) => void
}

const RequestList: React.FC<RequestListProps> = ({
  mode,
  serialResponse,
  watch,
  selectedServiceRequest,
  openedAccordionIndex,
  setOpenedAccordionIndex,
  getOnCheck,
}) => {
  if (mode === 'has-active') {
    return (
      <Stack sx={{ pt: '16px', gap: '4px' }}>
        {serialResponse?.receiver.activeRequest && (
          <NewServiceDrawerElement
            el={serialResponse?.receiver.activeRequest!}
            serialNumber={watch('serialNumber')}
            checkedIndex={selectedServiceRequest?.requestId ?? -1}
            defaultOpenedIndex={
              serialResponse?.receiver.activeRequest?.requestId!
            }
            index={serialResponse?.receiver.activeRequest?.requestId!}
            onCheck={() => getOnCheck(serialResponse?.receiver.activeRequest!)}
            openedAccordionIndex={openedAccordionIndex}
            setOpenedAccordionIndex={setOpenedAccordionIndex}
            variant='opened'
          />
        )}
        {serialResponse?.receiver.closedRequests?.map((el) => (
          <NewServiceDrawerElement
            key={el.requestId}
            el={el}
            serialNumber={watch('serialNumber')}
            checkedIndex={selectedServiceRequest?.requestId ?? -1}
            defaultOpenedIndex={
              serialResponse?.receiver.activeRequest?.requestId!
            }
            index={el.requestId}
            onCheck={() => getOnCheck(el)}
            openedAccordionIndex={openedAccordionIndex}
            setOpenedAccordionIndex={setOpenedAccordionIndex}
            variant='closed'
          />
        ))}
      </Stack>
    )
  }

  if (mode === 'has-closed') {
    return (
      <Stack sx={{ pt: '16px', gap: '4px' }}>
        {serialResponse?.receiver.closedRequests?.map((el) => (
          <NewServiceDrawerElement
            key={el.requestId}
            el={el}
            serialNumber={watch('serialNumber')}
            checkedIndex={selectedServiceRequest?.requestId ?? -1}
            defaultOpenedIndex={
              serialResponse?.receiver.activeRequest?.requestId!
            }
            index={el.requestId}
            onCheck={() => getOnCheck(el)}
            openedAccordionIndex={openedAccordionIndex}
            setOpenedAccordionIndex={setOpenedAccordionIndex}
            variant='closed'
          />
        ))}
      </Stack>
    )
  }

  return null
}

export default observer(RequestList)
